import React from "react";

import { Button as BaseButton } from "@/common/components/button/button";

type PlanUpgradeCtaProps = {
  icon: React.ReactNode;
  heading: React.ReactNode;
  description: React.ReactNode;
  children: React.ReactNode;
};

type ButtonProps = {
  onClick: () => void;
  children: React.ReactNode;
};

const Button = ({ children, onClick }: ButtonProps) => {
  return (
    <BaseButton
      className="basis-full disabled:cursor-wait sm:shrink-0 sm:basis-[30%] sm:self-center @max-sm:shrink @max-sm:basis-full @max-sm:self-auto"
      onClick={onClick}
      variant="primary"
    >
      {children}
    </BaseButton>
  );
};

const PlanUpgradeCta = ({
  children,
  description,
  heading,
  icon,
}: PlanUpgradeCtaProps) => {
  return (
    <aside className="shadow-can-light-box sticky bottom-4 flex flex-col gap-6 rounded-t-[24px] bg-white p-4 sm:flex-row sm:rounded-[24px] @max-sm:flex-col">
      <div className="bg-can-silver-gray self-center rounded-full p-8 sm:p-4">
        {icon}
      </div>
      <div className="flex flex-col items-center sm:grow sm:items-start @max-sm:items-center">
        <h3 className="text-can-midnight-steel font-bold">{heading}</h3>
        <p className="text-center text-xs sm:text-left @max-sm:text-center">
          {description}
        </p>
      </div>
      {children}
    </aside>
  );
};

export { Button, PlanUpgradeCta };
